<ac-card>
  <ac-card-content>
    <div class="ac-flex-col ac-gap-lg ac-ctr">
      <div class="region-icon ac-flex ac-ctr">
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4886 46.1834C20.4886 29.88 33.7025 16.6689 50.0002 16.6689C66.2979 16.6689 79.5147 29.8829 79.5147 46.1834C79.5147 55.6786 75.1157 63.5299 69.9089 69.4934C64.7022 75.457 58.5685 79.6859 54.7478 81.9987C53.3185 82.873 51.6756 83.3356 50.0002 83.3356C48.3248 83.3356 46.6818 82.873 45.2526 81.9987C41.4347 79.683 35.2982 75.4541 30.0943 69.4906C24.8875 63.527 20.4857 55.6758 20.4857 46.1806M60.1501 33.1112C60.6131 33.4532 61.1318 33.9067 61.7062 34.4717C62.2712 35.0462 62.7247 35.5639 63.0667 36.025C64.1636 37.4847 63.7044 39.2788 62.6132 40.4523C61.5475 41.5974 59.8072 43.4284 57.0975 46.1777C59.8072 48.9328 61.5475 50.7638 62.6132 51.9089C63.7044 53.0795 64.1636 54.8765 63.0667 56.3333C62.7247 56.7963 62.2712 57.314 61.7062 57.8866C61.2213 58.3774 60.7012 58.8321 60.1501 59.2471C58.6933 60.344 56.8991 59.8877 55.7285 58.7936C54.5806 57.7279 52.7524 55.9904 49.9974 53.2807C47.2423 55.9904 45.4142 57.7307 44.2719 58.7964C43.0985 59.8877 41.3015 60.344 39.8446 59.2499C39.2944 58.8348 38.7753 58.3801 38.2913 57.8894C37.8006 57.4045 37.3459 56.8845 36.9308 56.3333C35.8311 54.8765 36.2903 53.0795 37.3843 51.9089C38.4472 50.7638 40.1875 48.9328 42.8972 46.1806C40.1875 43.4256 38.4472 41.5974 37.3815 40.4523C36.2903 39.2788 35.8311 37.4847 36.928 36.025C37.2766 35.5658 37.7216 35.0443 38.2885 34.4717C38.8629 33.9086 39.3816 33.4551 39.8446 33.1112C41.3015 32.0143 43.0985 32.4735 44.2691 33.5647C45.4142 34.6305 47.2452 36.3708 49.9974 39.0804C52.7524 36.3708 54.5806 34.6305 55.7257 33.5647C56.8991 32.4735 58.6933 32.0143 60.1501 33.1112Z" fill="#94FF2A"/>
        </svg>
      </div>
      <div class="ac-flex-col ac-gap-md ac-ctr text-center">
        <div class="ac-headline-sm">
          Gains.com Isn't Available in Your Region
        </div>
        <div class="restricted-description ac-body-md">
          It looks like you are located in a restricted region. If you're using a VPN, try turning it off before attempting any action.
        </div>
      </div>
    </div>
  </ac-card-content>
  <ac-card-actions>
    <button
      mat-flat-button
      class="ac-primary ac-btn-lg"
      type="button"
      [loading]="checkLocationInProgress()"
      (click)="validate()">
      Check Location
    </button>
    <button
      mat-flat-button
      class="ac-secondary ac-btn-lg"
      type="button"
      (click)="close()">
      Close
    </button>

    <div class="ac-flex ac-ctr">
      <a class="ac-link ac-title-md" href="https://help.gains.com/en/articles/11625005-restricted-regions-where-gains-com-is-not-available" target="_blank">Learn More about Restricted Regions</a>
    </div>
  </ac-card-actions>
</ac-card>
